import { render, staticRenderFns } from "./ProjectDetails.vue?vue&type=template&id=9082b322&scoped=true"
import script from "./ProjectDetails.vue?vue&type=script&lang=js"
export * from "./ProjectDetails.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetails.vue?vue&type=style&index=0&id=9082b322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9082b322",
  null
  
)

export default component.exports